<button 
    size="small" 
    p-button  
    [pTooltip]="countDataChecked > 0 ? tooltipContent : ''"  
    tooltipPosition="bottom" 
    class="ml-3 split-button-orange-1" 
    [class.active]="countDataChecked > 0" 
    type="button" 
    (click)="showOverlayPanel($event)">
    {{label}} 
    <p-badge 
        *ngIf="countDataChecked > 0" 
        [styleClass]="'p-badge-danger'" 
        [value]="countDataChecked" />
</button>
<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <div class="split-dropdown-panel">
        <div class="split-dropdown-header">
            <split-search  class="w-full" (valueChange)="onSearch($event)"></split-search>
        </div>
        <div class="split-dropdown-list">
            <div class="split-dropdown-item" *ngFor="let dataFilter of _data; let i = index">
                <p-checkbox (click)="$event.stopPropagation()" [ngModel]="dataFilter?.checked" (onChange)="onChange($event, i)" [binary]="true" ></p-checkbox>
                <label class="ml-1" [for]="dataFilter.id">{{dataFilter.name}}</label>
            </div>
        </div>
        <div class="split-dropdown-footer">
            <p-button (click)="onEmit()" label="aplicar"></p-button>
        </div>
      </div>
</p-overlayPanel>

<ng-template #tooltipContent>
    <p class="my-1">Filtros selecionados: </p>
    <ul class="pl-4">
        <li *ngFor="let dataFilter of dataChecked; let i = index">{{ dataFilter.name }}</li>
    </ul>
</ng-template>